import api from './api';

export const initiateShopifyAuth = async (shopDomain) => {
  const { data } = await api.post('/shopify/auth', { shopDomain });
  return data;
};

export const getStores = async () => {
  const { data } = await api.get('/shopify/stores');
  return data;
};

export const getStoreMetafieldDefinitions = async (storeId, query) => {
  const { data } = await api.get(`/shopify/stores/${storeId}/metafield-definitions`, {
    params: { q: query },
  });
  return data;
};

export const disconnectStore = async (storeId) => {
  const { data } = await api.delete(`/shopify/stores/${storeId}`);
  return data;
};

export const setMainStore = async (storeId) => {
  const { data } = await api.patch(`/shopify/stores/${storeId}/main`);
  return data;
};

export const updateStoreNickname = async (storeId, nickname) => {
  const { data } = await api.patch(`/shopify/stores/${storeId}`, { nickname });
  return data;
};
